import styled from 'styled-components';
// import { Circles } from 'react-loader-spinner';

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin: 0;
  gap: 10px;
`;

// export const SlowCircles = styled(Circles)`
//   svg {
//     animation-duration: 1s;
// `;

// export const LoaderContainer = styled.div`
//   position: fixed; /* Ensures it's always positioned relative to the viewport */
//   top: 50%; /* Centers vertically */
//   left: 50%; /* Centers horizontally */
//   transform: translate(-50%, -50%); /* Shifts it back to the true center */
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   width: 100vw;
//   min-height: 100vh;
// `;
